import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class PercentageSlider extends React.Component {

  render() {
    return <div className={classNames({
      'percentage-slider': true,
      darken: this.props.darken || false
    })} style={{ width: `${ this.props.width || 100 }%` }}>
      <div className="percentage-slider-value"
           style={{ width: `${this.props.percentage || 100}%` }}>
      </div>
    </div>;
  }
}

PercentageSlider.propTypes = {
  percentage: PropTypes.number.isRequired,
  darken: PropTypes.bool,
  width: PropTypes.number
};
